import { render, staticRenderFns } from "./OrgAdminManageStaff.vue?vue&type=template&id=bec3e4cc&scoped=true&"
import script from "./OrgAdminManageStaff.vue?vue&type=script&lang=ts&"
export * from "./OrgAdminManageStaff.vue?vue&type=script&lang=ts&"
import style0 from "./OrgAdminManageStaff.vue?vue&type=style&index=0&id=bec3e4cc&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bec3e4cc",
  null
  
)

export default component.exports